"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
require("reflect-metadata");
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const common_1 = require("@angular/common");
const http_1 = require("@angular/common/http");
const static_1 = require("@angular/upgrade/static");
const forms_1 = require("@angular/forms");
const ngx_datatable_1 = require("@siemens/ngx-datatable");
const de_1 = __importDefault(require("@angular/common/locales/de"));
const de_2 = __importDefault(require("@angular/common/locales/extra/de"));
const upgrade_1 = require("@angular/common/upgrade");
const ngx_pagination_1 = require("ngx-pagination");
const vehicle_table_component_1 = require("./vehicle-table/vehicle-table.component");
const models_1 = require("./shared/models");
const services_1 = require("./shared/services");
const ajs_upgraded_providers_1 = require("./ajs-upgraded-providers");
const pipes_1 = require("./shared/pipes");
const vehicle_1 = require("./shared/models/vehicle");
const table_component_1 = require("./table-component/table.component");
const vehicle_editor_component_1 = require("./vehicle-editor/vehicle-editor.component");
const features_component_1 = require("./vehicle-editor/model-data/features/features.component");
const main_component_1 = require("./vehicle-editor/model-data/main/main.component");
const bodycode_form_component_1 = require("./bodycode-form/bodycode-form.component");
const data_check_component_1 = require("./vehicle-editor/model-data/data-check/data-check.component");
const support_component_1 = require("./support-form/support.component");
const vehicle_export_component_1 = __importDefault(require("./vehicle-export/vehicle-export.component"));
const chart_component_1 = __importDefault(require("./chart/chart.component"));
const transactions_component_1 = require("./transactions/transactions.component");
const customer_select_component_1 = require("./customer-select/customer-select.component");
const opportunity_table_component_1 = __importDefault(require("./opportunity-table/opportunity-table.component"));
const customer_form_component_1 = __importDefault(require("./customer-form/customer-form.component"));
const opportunity_1 = require("./shared/models/opportunity");
const opportunity_component_1 = __importDefault(require("./opportunity/opportunity.component"));
const offer_1 = require("./shared/models/offer");
const sidesheet_component_1 = __importDefault(require("./sidesheet/sidesheet.component"));
const customer_1 = require("./shared/models/customer");
const overlay_component_1 = __importDefault(require("./customer-select/overlay.component"));
const import_warning_component_1 = __importDefault(require("./vehicle-editor/import-warning/import-warning.component"));
const onboarding_component_1 = __importDefault(require("./onboarding/onboarding.component"));
const opportunity_form_component_1 = __importDefault(require("./opportunity-form/opportunity-form.component"));
const templates_1 = require("./shared/models/templates");
const custom_template_table_component_1 = __importDefault(require("./custom-template-table/custom-template-table.component"));
const custom_template_form_component_1 = __importDefault(require("./custom-template-form/custom-template-form.component"));
const building_blocks_1 = require("./custom-template-form/building-blocks");
const video_container_component_1 = __importDefault(require("./video-container/video-container.component"));
const custom_template_task_component_1 = __importDefault(require("./custom-template-form/custom-template-task/custom-template-task.component"));
const analysis_component_1 = __importDefault(require("./analysis/analysis.component"));
const sales_analysis_component_1 = __importDefault(require("./analysis/sales/sales-analysis.component"));
const handover_analysis_component_1 = __importDefault(require("./analysis/handover/handover-analysis.component"));
const pricing_component_1 = __importDefault(require("./vehicle-editor/pricing/pricing.component"));
const offer_sending_component_1 = __importDefault(require("./offer-sending/offer-sending.component"));
const emissions_component_1 = __importDefault(require("./vehicle-editor/emissions/emissions.component"));
let AppModule = class AppModule {
    constructor(upgrade) {
        this.upgrade = upgrade;
        (0, common_1.registerLocaleData)(de_1.default, 'de-DE', de_2.default);
    }
    ngDoBootstrap() {
        this.upgrade.bootstrap(document.body, ['autoboard'], { strictDi: true });
    }
};
AppModule = __decorate([
    (0, core_1.NgModule)({
        imports: [
            platform_browser_1.BrowserModule,
            ngx_pagination_1.NgxPaginationModule,
            common_1.CommonModule,
            http_1.HttpClientModule,
            forms_1.FormsModule,
            ngx_datatable_1.NgxDatatableModule,
            static_1.UpgradeModule,
            upgrade_1.LocationUpgradeModule.config(),
        ],
        exports: [
            common_1.CommonModule,
            platform_browser_1.BrowserModule,
        ],
        declarations: [
            pipes_1.Pipes,
            vehicle_table_component_1.VehicleTable,
            analysis_component_1.default,
            vehicle_editor_component_1.VehicleEditor,
            vehicle_1.VehicleComponents,
            vehicle_export_component_1.default,
            ajs_upgraded_providers_1.TagDirective,
            ajs_upgraded_providers_1.SelectDirective,
            ajs_upgraded_providers_1.DatepickerDirective,
            table_component_1.GenericTableComponent,
            ajs_upgraded_providers_1.VehicleDetail,
            ajs_upgraded_providers_1.BackdropRailComponent,
            ajs_upgraded_providers_1.BackdropRailItemComponent,
            ajs_upgraded_providers_1.UserNameDircetive,
            ajs_upgraded_providers_1.UserSelectDirective,
            features_component_1.VehicleModelDataFeatures,
            main_component_1.VehicleModelDataMain,
            bodycode_form_component_1.BodycodeForm,
            ajs_upgraded_providers_1.ProfileImageComponent,
            data_check_component_1.VehicleDataCheckComponent,
            ajs_upgraded_providers_1.DialogCommentsComponent,
            ajs_upgraded_providers_1.TierComponent,
            support_component_1.SupportComponent,
            chart_component_1.default,
            transactions_component_1.TransactionsComponent,
            customer_select_component_1.CustomerSelectComponent,
            overlay_component_1.default,
            opportunity_table_component_1.default,
            customer_form_component_1.default,
            ajs_upgraded_providers_1.BackdropOverlayComponent,
            ajs_upgraded_providers_1.BackdropOverlayTitleComponent,
            ajs_upgraded_providers_1.BackdropOverlayContentComponent,
            opportunity_1.OpportunityComponents,
            opportunity_component_1.default,
            customer_1.CustomerComponents,
            offer_1.OfferComponents,
            ajs_upgraded_providers_1.CommentComponent,
            ajs_upgraded_providers_1.BackdropToolbarComponent,
            sidesheet_component_1.default,
            import_warning_component_1.default,
            ajs_upgraded_providers_1.CardComponent,
            onboarding_component_1.default,
            ajs_upgraded_providers_1.StaticResourceComponent,
            opportunity_form_component_1.default,
            templates_1.TemplateComponents,
            ajs_upgraded_providers_1.FileComponent,
            custom_template_table_component_1.default,
            custom_template_form_component_1.default,
            custom_template_task_component_1.default,
            // BuildingBlockTitleComponent,
            building_blocks_1.BuildingBlockComponents,
            ajs_upgraded_providers_1.StaticUploadComponent,
            ajs_upgraded_providers_1.StaticLinkComponent,
            video_container_component_1.default,
            ajs_upgraded_providers_1.OverlayComponent,
            sales_analysis_component_1.default,
            handover_analysis_component_1.default,
            chart_component_1.default,
            pricing_component_1.default,
            offer_sending_component_1.default,
            emissions_component_1.default,
        ],
        entryComponents: [
            vehicle_table_component_1.VehicleTable,
            vehicle_1.VehicleComponents,
            vehicle_editor_component_1.VehicleEditor,
            vehicle_export_component_1.default,
            bodycode_form_component_1.BodycodeForm,
            data_check_component_1.VehicleDataCheckComponent,
            support_component_1.SupportComponent,
            chart_component_1.default,
            transactions_component_1.TransactionsComponent,
            opportunity_table_component_1.default,
            opportunity_component_1.default,
            customer_select_component_1.CustomerSelectComponent,
            customer_1.CustomerComponents,
            overlay_component_1.default,
            onboarding_component_1.default,
            opportunity_form_component_1.default,
            custom_template_table_component_1.default,
            custom_template_form_component_1.default,
            video_container_component_1.default,
            analysis_component_1.default,
            sales_analysis_component_1.default,
            handover_analysis_component_1.default,
            pricing_component_1.default,
            // DialogCommentsComponent,
        ],
        providers: [
            services_1.Services,
            models_1.Models,
            {
                provide: core_1.DEFAULT_CURRENCY_CODE,
                useValue: 'EUR',
            }, {
                provide: core_1.LOCALE_ID,
                useValue: 'de-DE',
            },
            ajs_upgraded_providers_1.configServiceProvider,
            ajs_upgraded_providers_1.constantsServiceProvider,
            ajs_upgraded_providers_1.socketServiceProvider,
            ajs_upgraded_providers_1.toastServiceProvider,
            ajs_upgraded_providers_1.salesApiServiceProvider,
            ajs_upgraded_providers_1.userServiceProvider,
            ajs_upgraded_providers_1.interfaceServiceProvider,
            bodycode_form_component_1.BodycodeForm,
            ajs_upgraded_providers_1.permissionsServiceProvider,
            ajs_upgraded_providers_1.supportApiServiceProvider,
            ajs_upgraded_providers_1.notificationServiceProvider,
            ajs_upgraded_providers_1.fileServiceProvider,
            ajs_upgraded_providers_1.tabServiceProvider,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof static_1.UpgradeModule !== "undefined" && static_1.UpgradeModule) === "function" ? _a : Object])
], AppModule);
exports.AppModule = AppModule;
